var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"rounded",attrs:{"src":_vm.logo_url}})}
var staticRenderFns = []

export { render, staticRenderFns }